import React, {useEffect, useImperativeHandle, useRef, useState} from "react";
import {
  Form,
  Row,
  Col,
  Space,
  DatePicker,
  Input,
  Button,
  Spin,
  message, Typography, notification,
} from "antd";

import {InputFields} from "components/common";


import {sharedDirectory,employeeService} from "api"
import dayjs from "dayjs";
import {useAppDispatch, useAppSelector} from "../../../../../../redux/hooks";
import {dataFields as inputFieldsInit } from "./config";
import {getChucVuAPI, getLCVAPI, getLHDAPI, getPhongBanAPI, getSGAPI} from "../../../../../../redux/reducer/employee";
import Notification from "../../../../../../components/common/notification/notification";
import { RangePickerProps } from "antd/es/date-picker";
import moment from "moment";
import { FORMAT_TIME } from "types/enums";

const FormAdd = props => {
  const {data, closeModal, type, getListApi, setCurrentPage} = props;
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState(null);
  const [form] = Form.useForm();
  const employees = useAppSelector(
      (state) => state.employeesReducer
  );
  const [provinces, setProvinces] = useState<any[] | null>(null);
  const [selectedProvince, setSelectedProvince] = useState<number>(null);
  const [fieldInfo, setFieldInfo] = useState(inputFieldsInit);
  const dispatch = useAppDispatch();
  useEffect(() => {
    const disabledDateStart: RangePickerProps["disabledDate"] = currentDate => {
      const endDay = form.getFieldValue("tuyenDungDenNgay");
      if (endDay) {
        return currentDate > endDay;
      }
    };
    const disabledDateEnd: RangePickerProps["disabledDate"] = currentDate => {
      const start = form.getFieldValue("tuyenDungTuNgay");
      if (start) {
        return currentDate < start;
      }
    };
    inputFieldsInit.find(e => e.name == "tuyenDungTuNgay").disabledDate = disabledDateStart;
    inputFieldsInit.find(e => e.name == "tuyenDungDenNgay").disabledDate = disabledDateEnd;
    setFieldInfo([...inputFieldsInit]);
  }, []);
  useEffect(() => {

    if (type == "Thêm") {
      newId();
      form.resetFields();
      form.setFieldValue("maDotTuyenDung",id);
    } else {
      form.setFieldsValue({
        ...data,

        tuyenDungTuNgay: data?.tuyenDungTuNgay
            ? dayjs(data.tuyenDungTuNgay)
            : null,
        tuyenDungDenNgay: data?.tuyenDungDenNgay
            ? dayjs(data.tuyenDungDenNgay)
            : null,

      });

    }
  }, [data ,id]);
  useEffect(() => {
    dispatch(getPhongBanAPI({
      page: 1,
      limit: 100,
    }));
    dispatch(getChucVuAPI({
      page: 1,
      limit: 100,
    }));
    fetchProvinces();

  }, []);

  useEffect(() => {
    setOptionsPBFields(
        employees.phongBanList,
        "idPhongBan"
    );
  }, [employees.phongBanList]);
  useEffect(() => {
    setOptionsDBFields(
        provinces,
        "diaBan"
    );
  }, [provinces]);
  useEffect(() => {
    setOptionsCVFields(
        employees.chucVuList,
        "idChucVu"
    );
  }, [employees.chucVuList]);
  const setOptionsDBFields = (list, name) => {
    if (fieldInfo.find((field) => field.name === name)) {
      fieldInfo.find((field) => field.name === name).options = list?.map(
          (item) => ({
            value: item.name,
            label: item.name,
          })
      );
      setFieldInfo([...fieldInfo]);
    }
  };
  const setOptionsPBFields = (list, tenPhongBan) => {
    if (fieldInfo.find((field) => field.name === tenPhongBan)) {
      fieldInfo.find((field) => field.name === tenPhongBan).options = list?.map(
          (item) => ({
            value: item.id,
            label: item.tenPhongBan,
          })
      );
      setFieldInfo([...fieldInfo]);
    }
  };
  const setOptionsCVFields = (list, tenChucVu) => {
    if (fieldInfo.find((field) => field.name === tenChucVu)) {
      fieldInfo.find((field) => field.name === tenChucVu).options = list?.map(
          (item) => ({
            value: item.id,
            label: item.tenChucVu,
          })
      );
      setFieldInfo([...fieldInfo]);
    }
  };

  const addApi = async () => {
    setLoading(true);
    const value = form.getFieldsValue();
    try {

      const params = {
        ...value,

      };
      await employeeService.updateRecruitment(params).then(res => {
        Notification("success", "Đã thêm mới thành công");

      });
      setLoading(false);
      closeModal();
      await getListApi({});


    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi thêm mới đợt tuyển dụng");

    }
  };
  const fetchProvinces = async () => {
    try {
      let response = await sharedDirectory.getListProvince();
      setProvinces(response.data);
    } catch (err) {
      Notification("error", "Lỗi khi lấy danh mục tỉnh");
    }
  };
  const editApi = async () => {
    setLoading(true);
    const value = form.getFieldsValue();

    try {
      const params = {
        ...value,
        id:data.id ,
      };
      const res = await employeeService.updateRecruitment(params).then(res => {
        Notification("success", "Đã sửa thành công");
      });;
      setLoading(false);
      closeModal();
      await getListApi({});

    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi sửa thông tin đợt tuyển dụng ");

    }
  };
  const newId = async () => {
    try {
      const res = await employeeService.getNewIdTD();
      setId(res);
    } catch (error) {
      Notification("error", "Đã có lỗi khi lấy mã đợt tuyển dụng");
    }
  };
  useEffect(() => {


    form.setFieldsValue({
      ...data,

      tuyenDungTuNgay: data?.tuyenDungTuNgay
          ? dayjs(data.tuyenDungTuNgay)
          : null,
      tuyenDungDenNgay: data?.tuyenDungDenNgay
          ? dayjs(data.tuyenDungDenNgay)
          : null,

    });


  }, [data]);

  const onFinish = values => {
    if (type == "Thêm") {
      addApi();
      newId();
    } else {
      editApi();
    }
  };
  return (
      <div>
        <Spin spinning={loading}>
          <Form form={form} onFinish={onFinish}>
            <Space direction="vertical" style={{width: "100%"}}>
              <Row gutter={[16, 14]}>

                <InputFields data={fieldInfo}></InputFields>
              </Row>
              <Row justify="end" style={{ marginTop: 12 }}>
                <Col>
                  <Space>
                    <Button onClick={closeModal} style={{ backgroundColor: "red", borderColor: "red" , color: "white"  }}>Hủy bỏ</Button>
                    <Button htmlType="submit" type="primary" >
                      Lưu lại
                    </Button>
                  </Space>{" "}
                </Col>
              </Row>
            </Space>
          </Form>
        </Spin>
      </div>
  );
};
export default FormAdd;
